import React from "react";
import Navbar from "./component/Navbar";
import Main from "./component/Main";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Explore from "./component/Explore";
import About from "./component/About";
import Calculator from "./component/Calculator";
import Bubblegame from "./component/Bubblegame";
import Footer from "./component/Footer";
import Resturant from "./component/Resturant";
import Quiz from "./component/Quiz";
import Weather from "./component/Weather";

function App() {
  return (
    <>
   <Router>
     <Navbar />
     <Routes>
       <Route path="/" element={<Main />}></Route>
       <Route path="/ex" element={<Explore />}></Route>
       <Route path="/abt" element={<About />}></Route>
       <Route path="/bbl" element={<Bubblegame />}></Route>
       <Route path="/sky" element={<Weather />}></Route>
       <Route path="/quiz" element={<Quiz />}></Route>
       <Route path="/res" element={<Resturant />}></Route>
       <Route path="/calc" element={<Calculator />}></Route>
       </Routes>
       <div className="container" style={{ marginTop: '120px', width: '100vw', maxWidth: '100%' }}>
          <Footer />
        </div>
     </Router>
    </>
  );
}

export default App;
